import script from "./disk-capacity-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./disk-capacity-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./disk-capacity-distribution-chart.vue?vue&type=style&index=0&id=71e85af4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e85af4"]])

export default __exports__